import TopMenu from '../components/TopMenu';
import BottomMenu from '../components/BottomMenu';
import { Container, Row, Col, Image } from 'react-bootstrap';
import TempImage from '../images/bluebox.png';
function About() {
    return (
        <div>
            <TopMenu />
            <Container>
                <Row className='justify-content-center'>
                    <Col md={6}>
                        <p>HT&T Truck Center began in 1946 as Hilo Transportation and Terminal Company,
                            a hauling company serving customers in Hilo, Hawaii. In 1946, when a tsunami hit
                            the island of Hawaii and destroyed tracks, bridges, and rolling stocks used to transport
                            sugarcane by train from the Hamakua Coast to Hilo Harbor, HT&T was created to haul the sugarcane by truck,
                            as well as to carry goods to tsunami-affected rural areas.
                            Later, HT&T expanded to sell truck parts and provide repair and maintenance services.</p>
                    </Col>
                    <Col md={3}>
                        <Image
                            src={TempImage}
                            fluid
                        />
                    </Col>
                </Row>
                <br />
                <Row className='justify-content-center'>
                    <Col md={3}>
                        <Image
                            src={TempImage}
                            fluid
                        />
                    </Col>
                    <Col md={6}>
                        <p>
                            For its first 53 years of existence, HT&T was a division of C. Brewer and its successor companies. In 1984,
                            the company opened a dealership in Waipahu, Oahu, while the Hilo hauling operation was continued under C. Brewer,
                            at that point renamed BEI, until eventually sold in 2003. In 1992 the dealership moved to its current location in
                            Iwilei, Oahu, close to downtown Honolulu and Honolulu Harbor. HT&T is majority owned by Marathon Group, a local
                            investment group, since 2002.
                        </p>
                    </Col>
                </Row>
                <br />
                <Row className='justify-content-center'>
                    <Col md={6}>
                        <p>
                            Today, HT&T is both successful and well known throughout local industry. HT&T is Hawaii’s largest
                            full-service dealership for heavy- and medium-duty trucks, and the sole
                            Hawaii authorized dealer for the Peterbilt, and Isuzu brands. For over 60 years, HT&T’s
                            mission has been to assist customers in becoming successful within their business lines by understanding their
                            unique transportation needs. The Company has continually evolved with Hawaii’s changing population and economy,
                            providing customized service for truck purchases, parts and inventory control, service and maintenance.
                        </p>
                    </Col>
                    <Col md={3}>
                        <Image
                            src={TempImage}
                        />
                    </Col>
                </Row>
                <br />
            </Container>
            <BottomMenu />
        </div>
    );
}

export default About;


/*
 <p>HT&T Truck Center began in 1946 as Hilo Transportation and Terminal Company,
                    a hauling company serving customers in Hilo, Hawaii. In 1946, when a tsunami hit
                    the island of Hawaii and destroyed tracks, bridges, and rolling stocks used to transport
                    sugarcane by train from the Hamakua Coast to Hilo Harbor, HT&T was created to haul the sugarcane by truck,
                    as well as to carry goods to tsunami-affected rural areas.
                    Later, HT&T expanded to sell truck parts and provide repair and maintenance services.</p>
                <p>
                    For its first 53 years of existence, HT&T was a division of C. Brewer and its successor companies. In 1984,
                    the company opened a dealership in Waipahu, Oahu, while the Hilo hauling operation was continued under C. Brewer,
                    at that point renamed BEI, until eventually sold in 2003. In 1992 the dealership moved to its current location in
                    Iwilei, Oahu, close to downtown Honolulu and Honolulu Harbor. HT&T is majority owned by Marathon Group, a local
                    investment group, since 2002.
                </p>
                <p>
                    Today, HT&T is both successful and well known throughout local industry. HT&T is Hawaii’s largest
                    full-service dealership for heavy- and medium-duty trucks, and the sole
                    Hawaii authorized dealer for the Peterbilt, Isuzu and McNeilus brands. For over 60 years, HT&T’s
                    mission has been to assist customers in becoming successful within their business lines by understanding their
                    unique transportation needs. The Company has continually evolved with Hawaii’s changing population and economy,
                    providing customized service for truck purchases, parts and inventory control, service and maintenance.
                </p>

*/